import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { EmployessApiUrls } from "./employess.enum";
import { environment } from "../../../environments/environment";
import { Moment } from "moment";
import * as moment from "moment";
import { Observable } from "rxjs";
import {
  IAwardsLineUpdate,
  IAwardsResponse,
} from "../../pages/employess/awards/awards-response.model";
import { IAwardEmployeeInfo } from "../../pages/employess/awards/models/award-employee-info.interfaces";
import { EmployeeTrainingBudgetModel } from "./models/employee-training-budget-model";
import { IHttpSuccessResponse } from "../models/http-success-reposonse.interfaces";
import { map } from "rxjs/operators";
import { EmployeeTrainingBudgetCommand } from "./models/employee-training-budget-command";
import { EmployeesCardHistoryResponse } from "../../pages/employess/edit-employee/models/history.model";
import { IDelegateEmployeeRequest } from "../../pages/employess/employee.model";
import {
  EmployeeFinanceDataListItem,
  EmployeeFinanceDataPayload,
  EmployeeFinanceDataResponse,
} from "../../pages/employess/employee-finance-data/employee-finance-data.model";

@Injectable()
export class EmployessService {
  constructor(private httpClient: HttpClient) {}

  getEmployess() {
    return this.httpClient.get(
      `${environment.apiUrl}${EmployessApiUrls.employess}`,
    );
  }

  downloadEmployees(
    isActiveOnly: boolean,
    fileType: any,
    isPrivate: boolean,
    careHomesQuery?: string,
  ) {
    return this.httpClient.get(
      `${environment.apiUrl}${EmployessApiUrls.employess}/download?isActiveOnly=${isActiveOnly}&fileType=${fileType}&isPrivate=${isPrivate}&${careHomesQuery}`,
    );
  }

  getMigrationShiftsData(employeeUid: string) {
    return this.httpClient.get(
      `${environment.apiUrl}${EmployessApiUrls.employess}/${employeeUid}/shift-migration`,
    );
  }

  saveMigrationShiftsData(employeeUid: string, data: any) {
    return this.httpClient.put(
      `${environment.apiUrl}${EmployessApiUrls.employess}/${employeeUid}/shift-migration`,
      data,
    );
  }

  getEmployeeNextSchedule(employeeUid: string, date: Moment) {
    return this.httpClient.get(
      `${environment.apiUrl}${
        EmployessApiUrls.nextScheduleString
      }${employeeUid}/nextSchedule?date=${moment(date).format("YYYY/MM/DD")}`,
    );
  }

  getActiveEmployess() {
    return this.httpClient.get(
      `${environment.apiUrl}${EmployessApiUrls.activeEmployees}`,
    );
  }

  getActiveEmployessShort() {
    return this.httpClient.get(
      `${environment.apiUrl}${EmployessApiUrls.activeEmployees}&format=short`,
    );
  }

  getEmployeesAwards(careHomeId: number, startDate: string, endDate: string) {
    return this.httpClient.get<{ message: string; result: IAwardsResponse }>(
      `${environment.apiUrl}${EmployessApiUrls.awards}${careHomeId}/awards?startDateFormated=${startDate}&endDateFormated=${endDate}`,
    );
  }

  // downloadAwardXLS(careHomeId: number, scheduleDate: Moment) {
  downloadAwardXLS(careHomeId: number, startDate: string, endDate: string) {
    return this.httpClient.get(
      `${environment.apiUrl}${EmployessApiUrls.awards}${careHomeId}/awards/xls?startDateFormated=${startDate}&endDateFormated=${endDate}`,
      // }${careHomeId}/awards/xls?&monthDate=${moment(scheduleDate).format(
      //   "YYYY/MM/DD"
      // )}`
    );
  }
  getEmployeesByCareHome(careHomeId: number, activeOnly = true) {
    return this.httpClient.get(
      `${environment.apiUrl}${EmployessApiUrls.employeesSkip}?careHomeId=${careHomeId}&activeOnly=${activeOnly}`,
    );
  }

  getActiveEmployeesByCareHome(careHomeId: number) {
    return this.httpClient.get(
      `${environment.apiUrl}${EmployessApiUrls.activeEmployeesSkip}&careHomeId=${careHomeId}&format=short`,
    );
  }

  getEmployeesWithoutCareHome() {
    return this.httpClient.get(
      `${environment.apiUrl}${EmployessApiUrls.employeesSkip}`,
    );
  }

  getEmployee(employeeUid: string) {
    return this.httpClient.get(
      `${environment.apiUrl}${EmployessApiUrls.employess}/${employeeUid}`,
    );
  }

  getEmployeeTraining(employeeUid: string) {
    return this.httpClient.get(
      `${environment.apiUrl}${EmployessApiUrls.employess}/${employeeUid}/training-details`,
    );
  }

  getEmployeeActivations(employeeUid: string) {
    return this.httpClient.get(
      `${environment.apiUrl}${EmployessApiUrls.employess}/${employeeUid}/activate`,
    );
  }

  addEmployee(data: any) {
    return this.httpClient.post(
      `${environment.apiUrl}${EmployessApiUrls.employess}`,
      data,
    );
  }

  updateEmployee(employeeUid: string, data: any) {
    return this.httpClient.put(
      `${environment.apiUrl}${EmployessApiUrls.employess}/${employeeUid}`,
      data,
    );
  }

  patchEmployee(employeeUid: string, data: any) {
    return this.httpClient.patch(
      `${environment.apiUrl}${EmployessApiUrls.employess}/${employeeUid}`,
      data,
    );
  }

  updateAwards(careHomeId: number, data: IAwardEmployeeInfo) {
    return this.httpClient.put(
      `${environment.apiUrl}${EmployessApiUrls.awards}${careHomeId}/awards`,
      data,
    );
  }
  updateAwardsLine(careHomeId: number, data: IAwardsLineUpdate) {
    return this.httpClient.put(
      `${environment.apiUrl}${EmployessApiUrls.awards}${careHomeId}/awards/${data.awardId}`,
      data,
    );
  }
  resetPasswordAndSendInvitation(employeeUid: string, data: any) {
    return this.httpClient.post(
      `${environment.apiUrl}${EmployessApiUrls.employess}/${employeeUid}/send-invitation`,
      data,
    );
  }

  deleteEmployee(employeeUid: string) {
    return this.httpClient.delete(
      `${environment.apiUrl}${EmployessApiUrls.employess}/${employeeUid}`,
    );
  }

  getContractsByEmployeeUid(employeeUid: string) {
    return this.httpClient.get(
      `${environment.apiUrl}${EmployessApiUrls.employess}/${employeeUid}${EmployessApiUrls.contracts}`,
    );
  }

  getContractsByEmployeeUidInAddContractMode(employeeUid: string) {
    return this.httpClient.get(
      `${environment.apiUrl}${EmployessApiUrls.employess}/${employeeUid}${EmployessApiUrls.contracts}?addContractMode=true`,
    );
  }

  getContractsByEmployeeUidAndCalculateEvents(employeeUid: string) {
    return this.httpClient.get(
      `${environment.apiUrl}${EmployessApiUrls.employess}/${employeeUid}${EmployessApiUrls.contracts}?calculateEvents=true&dismissalProcess=true`,
    );
  }

  getContractsByEmployeeUidAndDate(
    employeeUid: string,
    startDate: Moment,
    endDate: Moment,
  ) {
    return this.httpClient.get(
      `${environment.apiUrl}${EmployessApiUrls.employess}/${employeeUid}${
        EmployessApiUrls.contracts
      }?startDateFormated=${moment(startDate).format(
        "YYYY/MM/DD",
      )}&endDateFormated=${moment(endDate).format("YYYY/MM/DD")}`,
    );
  }

  getContractsByEmployeeUidAndDateForAL(
    employeeUid: string,
    startDate: Moment,
    endDate: Moment,
    alCalculation = false,
  ) {
    return this.httpClient.get(
      `${environment.apiUrl}${EmployessApiUrls.employess}/${employeeUid}${
        EmployessApiUrls.contracts
      }?calculateEvents=true&startDateFormated=${moment(startDate).format(
        "YYYY/MM/DD",
      )}&endDateFormated=${moment(endDate).format(
        "YYYY/MM/DD",
      )}&alCalculation=${alCalculation}`,
    );
  }

  getUnaggregatedContractsWithoutCareHome(
    employeeUid: string,
    activeOnly: boolean = true,
  ) {
    const url = activeOnly
      ? EmployessApiUrls.activeContractsListSkip + "&calculateEvents=true"
      : EmployessApiUrls.contractsListSkip + "?calculateEvents=true";
    return this.httpClient.get(
      `${environment.apiUrl}${EmployessApiUrls.employess}/${employeeUid}${url}`,
    );
  }

  getEmployeePayroll(employeeUid: string) {
    return this.httpClient.get(
      `${environment.apiUrl}${EmployessApiUrls.employess}/${employeeUid}${EmployessApiUrls.payroll}`,
    );
  }

  getEventsByEmployeeUid(employeeUid: string) {
    return this.httpClient.get(
      `${environment.apiUrl}${EmployessApiUrls.employess}/${employeeUid}${EmployessApiUrls.events}`,
    );
  }

  getEventsToAccept() {
    return this.httpClient.get(
      `${environment.apiUrl}${EmployessApiUrls.employess}${EmployessApiUrls.eventsList}?waitingForAcceptance=true&dashboardVersion=true`,
    );
  }

  getEventsWithoutFirstDateAvailable() {
    return this.httpClient.get(
      `${environment.apiUrl}${EmployessApiUrls.employess}${EmployessApiUrls.eventsList}?firstDayAvailable=null&dashboardVersion=true`,
    );
  }

  getUnaggregatedEventsByEmployeeUid(employeeUid: string) {
    return this.httpClient.get(
      `${environment.apiUrl}${EmployessApiUrls.employess}/${employeeUid}${EmployessApiUrls.eventsList}`,
    );
  }

  getUnaggregatedEventsWithoutCareHome(
    employeeUid: string,
    activeOnly: boolean = true,
    eventType: string = "",
  ) {
    return this.httpClient.get(
      `${environment.apiUrl}${EmployessApiUrls.employess}/${employeeUid}${EmployessApiUrls.eventsListSkip}?activeOnly=${activeOnly}&type=${eventType}`,
    );
  }

  getUnaggregatedActiveEventsByContractId(
    employeeUid: string,
    contractId: number,
  ) {
    return this.httpClient.get(
      `${environment.apiUrl}${EmployessApiUrls.employess}/${employeeUid}${EmployessApiUrls.eventsListSkip}?activeOnly=true&contractId=${contractId}`,
    );
  }

  getUnaggregatedCoursesWithoutCareHome(employeeUid: string) {
    return this.httpClient.get(
      `${environment.apiUrl}${EmployessApiUrls.employess}/${employeeUid}${EmployessApiUrls.coursesListSkip}`,
    );
  }

  getEmployeeSchedule(
    employeeUid: string,
    from?: number,
    to?: number,
    orderBy?: string,
    orderDirection?: string,
    filter?: any,
  ) {
    return this.httpClient.get(
      `${environment.apiUrl}${EmployessApiUrls.employess}/${employeeUid}${EmployessApiUrls.scheduleList}?rowsFrom=${from}&rowsTo=${to}&orderBy=${orderBy}&orderDirection=${orderDirection}&filter=${filter}`,
    );
  }

  getAnnualLeavingsByEmployeeUid(employeeUid: string) {
    return this.httpClient.get(
      `${environment.apiUrl}${EmployessApiUrls.employess}/${employeeUid}${EmployessApiUrls.annualLeavings}`,
    );
  }

  cancelEvent(eventId: number, data: any) {
    return this.httpClient.put(
      `${environment.apiUrl}${EmployessApiUrls.employess}/events/${eventId}`,
      data,
    );
  }

  shortenEvent(eventId: number, data: any) {
    return this.httpClient.put(
      `${environment.apiUrl}${EmployessApiUrls.employess}/events/${eventId}/shorten`,
      data,
    );
  }

  getAvatar(id: any): Observable<Blob> {
    return this.httpClient.get(
      `${environment.apiUrl}${EmployessApiUrls.employess}/${id}/avatars`,
      { responseType: "blob" },
    );
  }

  downloadNspf01(employeeUid: string): any {
    return this.httpClient.get(
      `${environment.apiUrl}${EmployessApiUrls.employess}/${employeeUid}/${EmployessApiUrls.nspf01}`,
    );
  }

  addToDismissalProcess(employeeUid: string, data: any) {
    return this.httpClient.post(
      `${environment.apiUrl}${EmployessApiUrls.employess}/${employeeUid}/dismissal-process`,
      data,
    );
  }

  updateDismissalProcess(employeeUid: string, data: any) {
    return this.httpClient.put(
      `${environment.apiUrl}${EmployessApiUrls.employess}/${employeeUid}/dismissal-process`,
      data,
    );
  }

  uploadTrainingDetails(employeeUid: string, careHomeId: number, data: any) {
    return this.httpClient.post(
      `${environment.apiUrl}${EmployessApiUrls.employess}/${employeeUid}/training-details?careHomeId=${careHomeId}`,
      data,
    );
  }

  uploadEmployeeActivation(employeeUid: string, data: any) {
    return this.httpClient.post(
      `${environment.apiUrl}${EmployessApiUrls.employess}/${employeeUid}/activate`,
      data,
    );
  }

  migrateEmployee(
    employeeUid: string,
    data: { careHomeId: number; changeDate: string },
  ) {
    return this.httpClient.put(
      `${environment.apiUrl}${EmployessApiUrls.employess}/${employeeUid}/care-home`,
      data,
    );
  }

  updateTrainingDetails(
    employeeUid: string,
    trainingId: number,
    careHomeId: number,
    data: any,
  ) {
    return this.httpClient.put(
      `${environment.apiUrl}${EmployessApiUrls.employess}/${employeeUid}/training-details/${trainingId}?careHomeId=${careHomeId}`,
      data,
    );
  }

  getDismissalProcessValues(employeeUid: string) {
    return this.httpClient.get(
      `${environment.apiUrl}${EmployessApiUrls.employess}/${employeeUid}/dismissal-process`,
    );
  }

  getEmployeeFinanceReport(employeeUid: string) {
    return this.httpClient.get(
      `${environment.apiUrl}${EmployessApiUrls.employess}/${employeeUid}/finance-report`,
    );
  }

  getEmployeeDocuments(employeeUid: string) {
    return this.httpClient.get(
      `${environment.apiUrl}${EmployessApiUrls.employess}/${employeeUid}/documents`,
    );
  }

  addEmployeeDocument(employeeUid: string, data: any) {
    return this.httpClient.post(
      `${environment.apiUrl}${EmployessApiUrls.employess}/${employeeUid}/documents`,
      data,
    );
  }

  addTaskWithEmployeeDocument(employeeUid: string, data: any) {
    return this.httpClient.post(
      `${environment.apiUrl}${EmployessApiUrls.employess}/${employeeUid}/documents-add-task`,
      data,
    );
  }

  addDocumentDescription(uid: any, data: any) {
    return this.httpClient.put(
      `${environment.apiUrl}${EmployessApiUrls.employess}/${uid}/documents-description`,
      data,
    );
  }

  deleteEmployeeDocument(employeeUid: string, fileUId: string) {
    return this.httpClient.delete(
      `${environment.apiUrl}${EmployessApiUrls.employess}/${employeeUid}/documents/${fileUId}`,
    );
  }

  downloadEmployeeDocument(employeeUid: string, fileUId: string) {
    return this.httpClient.get(
      `${environment.apiUrl}${EmployessApiUrls.employess}/${employeeUid}/documents/${fileUId}`,
    );
  }

  createReplacement(data: any) {
    return this.httpClient.post(
      `${environment.apiUrl}${EmployessApiUrls.rotaReplacement}`,
      data,
    );
  }

  public getEmployeeTrainingBudget(
    employeeUid: string,
  ): Observable<EmployeeTrainingBudgetModel> {
    return this.httpClient
      .get<
        IHttpSuccessResponse<EmployeeTrainingBudgetModel>
      >(`${environment.apiUrl}${EmployessApiUrls.employess}/${employeeUid}/training-budget`)
      .pipe(map((item) => item.result));
  }

  public updateEmployeeTrainingBudget(
    employeeUid: string,
    body: EmployeeTrainingBudgetCommand,
  ): Observable<any> {
    return this.httpClient.put<Observable<any>>(
      `${environment.apiUrl}${EmployessApiUrls.employess}/${employeeUid}/training-budget`,
      body,
    );
  }

  getEmployeeHistory(
    employeeUid: string,
  ): Observable<EmployeesCardHistoryResponse> {
    return this.httpClient.get<EmployeesCardHistoryResponse>(
      `${environment.apiUrl}${EmployessApiUrls.employess}/${employeeUid}/card-history`,
    );
  }

  delegateEmployee(employeeUid: string, body: IDelegateEmployeeRequest) {
    return this.httpClient.post<any>(
      `${environment.apiUrl}${EmployessApiUrls.employess}/${employeeUid}/delegations`,
      body,
    );
  }

  getEmployeeFinanceData(
    employeeUid: string,
  ): Observable<IHttpSuccessResponse<EmployeeFinanceDataResponse>> {
    return this.httpClient.get<
      IHttpSuccessResponse<EmployeeFinanceDataResponse>
    >(
      `${environment.apiUrl}${EmployessApiUrls.employess}/${employeeUid}/finance-data`,
    );
  }

  addEmployeeFinanceDataItem(
    employeeUid: string,
    payload: EmployeeFinanceDataPayload,
  ): Observable<IHttpSuccessResponse<EmployeeFinanceDataListItem>> {
    return this.httpClient.post<
      IHttpSuccessResponse<EmployeeFinanceDataListItem>
    >(
      `${environment.apiUrl}${EmployessApiUrls.employess}/${employeeUid}/finance-data`,
      payload,
    );
  }

  deleteEmployeeFinanceDataItem(
    employeeUid: string,
    financeDataItemUid: string,
  ): Observable<void> {
    return this.httpClient.delete<void>(
      `${environment.apiUrl}${EmployessApiUrls.employess}/${employeeUid}/finance-data/${financeDataItemUid}`,
    );
  }
}
